// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2a-3U","top":"styles_top__1GVrL"};